












import { Component, Prop, Vue } from 'vue-property-decorator';
import { formatMoney } from '@/utils/format';

@Component({
  name: 'PaymentOrderHeader',
})
export default class PaymentOrderHeader extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  readonly initiatingPartyName!: string;

  @Prop({
    type: Number,
    required: true,
  })
  readonly numberOfTransactions!: number

  @Prop({
    type: Number,
    required: true,
  })
  readonly controlSum!: number

  get controlSumFormatted() {
    return formatMoney(this.controlSum);
  }
}
